/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Delivery_Pickup_LabelInputs */

const en_dispatch_delivery_pickup_label = /** @type {(inputs: Dispatch_Delivery_Pickup_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup`)
};

const fr_dispatch_delivery_pickup_label = /** @type {(inputs: Dispatch_Delivery_Pickup_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération`)
};

const ms_sg2_dispatch_delivery_pickup_label = /** @type {(inputs: Dispatch_Delivery_Pickup_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengambilan`)
};

/**
* | output |
* | --- |
* | "Pickup" |
*
* @param {Dispatch_Delivery_Pickup_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_delivery_pickup_label = /** @type {((inputs?: Dispatch_Delivery_Pickup_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Delivery_Pickup_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_delivery_pickup_label(inputs)
	if (locale === "fr") return fr_dispatch_delivery_pickup_label(inputs)
	return ms_sg2_dispatch_delivery_pickup_label(inputs)
});